/**
 * Created by M on 2018/4/28.
 */
import Vue from "vue";
import * as BusinessEnums from "../BusinessEnums";
import Sortable from "sortablejs";
import { AppConsts } from "cf/packages/abpVue/AppConsts";
import l from 'cf/packages/abpVue/utils/abp.localization'

Vue.filter("businessEnumFilter", function(value, enumName) {
  var exist = _.find(BusinessEnums[enumName], x => x.key == (value || ""));
  if (exist) {
    return l(exist.key);
  }
  return "";
});

Vue.filter("dateFormat", function(value, format) {
  return moment(value).format(format);
});

Vue.directive("coursewareTypeicon", {
  bind: function(el, binding, vnode) {
    if (binding.value == "DOC") {
      el.className = "fa fa-file-text-o";
    } else if (binding.value == "VIDEO") {
      el.className = "fa fa-film";
    } else if (binding.value == "SCORM") {
      el.className = "fa fa-folder-o";
    }
  }
});

Vue.directive("table-sortable", {
  bind: function(el, binding, vnode) {
    const table = el.querySelector(".el-table__body-wrapper tbody");

    var sortPath = "",
      handle = "";

    var pIndex = 0;
    for (var p in binding.modifiers) {
      pIndex++;
      if (pIndex == 1) {
        //第一个参数是排序
        sortPath = p;
      } else if (pIndex == 2) {
        //第二个参数是拖拽的类名
        handle = "." + p;
      }
    }

    Sortable.create(table, {
      handle: handle,
      onEnd({ newIndex, oldIndex }) {
        var rows = vnode.componentInstance.data; //eltable实例的data属性

        //更改数组位置
        const targetRow = rows.splice(oldIndex, 1)[0];
        rows.splice(newIndex, 0, targetRow);

        if (sortPath) {
          //有排序字段，更改排序字段
          for (var i = 0; i < rows.length; i++) {
            rows[i][sortPath] = i + 1;
          }
        }
      }
    });
  }
});

//使用方式 v-image="src"   竖向模式 v-image:v="src"
Vue.directive("image", {
  // 当绑定元素插入到 DOM 中。
  bind: function(el, binding) {
    var onerror = function() {
      if (binding.arg == "v") {
        el.src = "/static/img/error_v.gif";
      } else if (binding.arg == "user") {
        el.src = "/static/img/defaultUserPhoto.jpg";
      } else {
        el.src = "/static/img/error.gif";
      }
    };

    // 聚焦元素
    if (binding.value && binding.value != "null") {
      el.src =
        AppConsts.remoteServiceBaseUrl +
        "sys/file/previewFile?fileName=" +
        encodeURI(binding.value);
    } else {
      onerror();
    }

    el.onerror = onerror;
  },
  update: function(el, binding) {
    if (binding.value != binding.oldValue) {
      el.src =
        AppConsts.remoteServiceBaseUrl +
        "sys/file/previewFile?fileName=" +
        encodeURI(binding.value);
    }
  }
});
// 注册一个全局自定义指令 v-avatar
Vue.directive("avatar", {
  // 当绑定元素插入到 DOM 中。
  bind: function(el, binding) {
    var onerror = function() {
      el.src = "/static/img/avatar3_small.jpg";
    };

    // 聚焦元素
    if (binding.value) {
      el.src =
        AppConsts.remoteServiceBaseUrl +
        "sys/file/previewFile?fileName=" +
        encodeURI(binding.value);
    } else {
      onerror();
    }
    el.onerror = onerror;
  },
  update: function(el, binding) {
    if (binding.value != binding.oldValue) {
      el.src = binding.value;
    }
  }
});

// 注册一个全局自定义指令 v-logo
Vue.directive("logo", {
  // 当绑定元素插入到 DOM 中。
  bind: function(el, binding) {
    var onerror = function() {
      el.src = "/static/img/logo.png";
    };

    // 聚焦元素
    if (binding.value) {
      el.src =
        AppConsts.remoteServiceBaseUrl +
        "sys/file/previewFile?fileName=" +
        encodeURI(binding.value);
    } else {
      onerror();
    }
    el.onerror = onerror;
  },
  update: function(el, binding) {
    if (binding.value != binding.oldValue) {
      el.src = binding.value;
    }
  }
});

Vue.directive("keypress", {
  bind: function(el, binding) {
    var f = binding.value;

    el.onkeypress = function(e) {
      if (e.keyCode == 13) {
        if (
          document.activeElement &&
          (document.activeElement.tagName.toLowerCase() == "input" ||
            document.activeElement.children[0].tagName.toLowerCase() == "input")
        ) {
          if (f) {
            f();
          }
        }
      }
    };
  }
});



// WEBPACK FOOTER //
// ./src/config/global/filters.js